'use strict';

import { _form } from './_form';
import { stateCity } from '../../modules/select';

const create = {
  init() {
    _form();
    stateCity();
  },
};

const _this = create;

export default _this;
